import { useState } from "react";
// import "./feedback.css";
import { Button, Stack, Tooltip } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import FlagIcon from "@mui/icons-material/Flag";
import { useSaveInteraction } from "../../utils/useSaveInteraction";
// import Replay from "@mui/icons-material/Replay";

export const Feedback: React.FC<{ index: string; videoID?: string }> = ({
  index,
  videoID,
}) => {
  const { saveInteraction } = useSaveInteraction();
  const [status, setStatus] = useState<number>(0);
  const [replyStatus, setReplyStatus] = useState<boolean>(false);

  const handleFeedback = async (status: number) => {
    setStatus(status);
    console.log("The button for this pair is clicked:", index, status);
    saveInteraction({
      name: "frontend-interaction-thumbs",
      context: {
        chatMessage: {uniqueID: index},
        thumbsValue: status
      }
    })

    // const SaveThumb = async () => {
    //   try {
    //     await apiClient.codeInterpreterSaveDataPost({
    //       codeInterpreterSaveDataPostRequest: {
    //         flag: "Thumbs",
    //         messages: [{ uniqueID: index, thumbsValue: status }],
    //       },
    //     });

    //     console.log("Thumbs saved successfully");
    //   } catch (error) {
    //     console.error("Error saving Thumb:", error);
    //     // Handle the error appropriately, such as displaying an error message to the user
    //   }
    // };
    // SaveThumb();

    // await apiClient.feedbackPost({
    //   feedbackPostRequest: {
    //     chatIndex: index,
    //     thumbsValue: status,
    //     videoID: videoID,
    //   },
    // });
  };

  const handleResponse = async () => {
    const reply = prompt("Please enter your response:", "") || "";
    saveInteraction({
      name: "frontend-interaction-feedback-flag",
      context: {
        messages: {uniqueID: index, reply: reply}
      }
    })

    // const SaveResponse = async (reply: string) => {
    //   try {
    //     await apiClient.codeInterpreterSaveDataPost({
    //       codeInterpreterSaveDataPostRequest: {
    //         flag: "Reply",
    //         messages: [{ uniqueID: index, reply: reply }],
    //       },
    //     });

    //     console.log("Reply saved successfully");
    //   } catch (error) {
    //     console.error("Error saving Reply:", error);
    //     // Handle the error appropriately, such as displaying an error message to the user
    //   }
    // };
    // SaveResponse(reply);
    setReplyStatus(true);
  };

  return (
    <Stack direction="row" spacing={1}>
      <Button
        variant="outlined"
        color="success"
        onClick={() => handleFeedback(1)}
        sx={
          status === -1
            ? {
                display: "none",
              }
            : undefined
        }
        disabled={status !== 0}
      >
        <ThumbUpIcon />
      </Button>
      <Button
        variant="outlined"
        color="error"
        onClick={() => handleFeedback(-1)}
        sx={
          status === 1
            ? {
                display: "none",
              }
            : undefined
        }
        disabled={status !== 0}
      >
        <ThumbDownIcon />
      </Button>

      <Tooltip title="Give Feedback!">
      <Button
        variant="outlined"
        color="warning"
        onClick={() => handleResponse()}
        disabled={replyStatus}
      >
        <FlagIcon />
      </Button>
      </Tooltip>
    </Stack>
  );
};
